var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle-question-solid",
    fill: "#8E8E93",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256,512 C397.4,512 512,397.4 512,256 C512,114.6 397.4,0 256,0 C114.6,0 0,114.6 0,256 C0,397.4 114.6,512 256,512 Z M169.8,165.3 C177.7,143 200.275218,119.82096 223.975218,119.82096 C239.111201,118.998305 249.530927,118.538063 255.234395,118.440233 C260.937863,118.342404 269.493064,118.802646 280.9,119.82096 C315.8,119.82096 344,156.3 344,191.1 C344,213.7 331.9,234.6 312.3,245.9 L280,264.4 C279.8,277.4 269.1,288 256,288 C242.7,288 232,277.3 232,264 L232,250.5 C232,241.9 236.6,234 244.1,229.7 L288.4,204.3 C293.1,201.6 296,196.6 296,191.2 C296,182.8 288.3,169.190173 280,169.190173 L228.420586,169.190173 C225.020586,169.190173 216.2,178.2 215.1,181.4 L214.7,182.6 C210.3,195.1 196.5,201.6 184.1,197.2 C171.7,192.8 165.1,179 169.5,166.6 L169.9,165.4 L169.8,165.3 Z M288,352 C288,369.7 273.7,384 256,384 C238.3,384 224,369.7 224,352 C224,334.3 238.3,320 256,320 C273.7,320 288,334.3 288,352 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.4935210428f0c6d807fa7f4f93c28445.svg";
export { ForwardRef as ReactComponent };